// jQuery(document).ready(function(){
//     jQuery('.video-section__poster').click();
// })

// jQuery(window).on('load',function(){
//   setTimeout(function () {
//       jQuery('.video-section .video-section__poster').click();
//    }, 1000);
//   setTimeout(function () {
//       jQuery('.video-section .video-section__poster').click();
//    }, 1500);
// });

jQuery(window).scroll(function() {    
  
    var scroll = $(window).scrollTop();

     //>=, not <=
    if (scroll >= 500) {
        //clearHeader, not clearheader - caps H
        jQuery(".sticky-atc-stay").attr('id', 'sticky-atc');
    }else{
        jQuery(".sticky-atc-stay").removeAttr('id', 'sticky-atc');
    }
});



// Mug Collection Page
jQuery(document).ready(function ($) {
    var canonical = "";
    var links = document.getElementsByTagName("link");
    for (var i = 0; i < links.length; i ++) {
        if (links[i].getAttribute("rel") === "canonical") {
            canonical = links[i].getAttribute("href")
        }
    }
    if(canonical == '#'){
        // var $divleft = jQuery('<div><img width="42%" src="https://cdn.shopify.com/s/files/1/0713/3249/5642/files/output-onlinegiftools_a78b7290-3fa0-454b-8a7a-7fb79c02bffa.gif?v=1684901881"></div>').appendTo('body');
        var $divleft = jQuery('<div  style="left: 2.2%"><img width="165" src="https://cdn.shopify.com/s/files/1/0820/1483/0869/files/PINK_CUSTOMIZE_BUTTON_4.png?v=1707724053"></div>').appendTo('body');
        $divleft.attr('id', 'holdy-left');
    }

  // ++++ homepage video ++++
    // setTimeout(function () {
    //   const video = $('#pcv_home_video')[0]; 
    //   if (video) {
    //     video.play();
    //   }
    // }, 300); 
    setTimeout(function () {
      $('.pcv_home_video').each(function () {
        var video = this; 
        if (video && typeof video.play === 'function') {
          video.play();
        }
      });
    }, 300);
    
  // ++++ Pride eCard page - Auto play video ++++
  if (window.location.pathname.includes('free-pride-ecard')) {
    setTimeout(function () {
      var videoPoster = document.querySelector('#shopify-section-template--23350085779733__video_BcfbFa .video-section__poster');
      if (videoPoster) {
        videoPoster.click();
      }
    }, 500);

    setTimeout(function () {
      var videoSection = document.querySelector('#shopify-section-template--23350085779733__video_BcfbFa');
      var videoWrapper = videoSection?.querySelector('.video-section');

      if (videoWrapper && !videoWrapper.querySelector('.floating-elements')) {
        var floatingContainer = document.createElement('div');
        floatingContainer.className = 'floating-elements';

        for (var i = 0; i < 7; i++) {
          var heart = document.createElement('div');
          heart.className = 'heart-float';
          floatingContainer.appendChild(heart);
        }

        for (var i = 0; i < 5; i++) {
          var sparkle = document.createElement('div');
          sparkle.className = 'sparkle-float';
          floatingContainer.appendChild(sparkle);
        }

        videoWrapper.insertBefore(floatingContainer, videoWrapper.firstChild);

        var videoContainer = videoWrapper.querySelector('.video-section__media');
        if (videoContainer && !videoWrapper.querySelector('.video-section__heading')) {
          var videoHeadline = document.createElement('h2');
          videoHeadline.className = 'video-section__heading';
          videoHeadline.textContent = 'Watch the Magic';
          videoWrapper.insertBefore(videoHeadline, videoContainer);
        }
      }

      var formSection = document.querySelector('[id*="1779362767462e7f48"]');
      if (formSection && !formSection.querySelector('.floating-elements')) {
        var container = document.createElement('div');
        container.className = 'floating-elements';
        for (var j = 0; j < 4; j++) {
          var h = document.createElement('div');
          h.className = 'heart-float';
          container.appendChild(h);
        }
        for (var k = 0; k < 3; k++) {
          var s = document.createElement('div');
          s.className = 'sparkle-float';
          container.appendChild(s);
        }
        formSection.insertBefore(container, formSection.firstChild);
      }
    }, 600);
  }
});


